import { render, staticRenderFns } from "./top-down.vue?vue&type=template&id=70025b17&scoped=true"
import script from "./top-down.vue?vue&type=script&lang=js"
export * from "./top-down.vue?vue&type=script&lang=js"
import style0 from "./top-down.vue?vue&type=style&index=0&id=70025b17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70025b17",
  null
  
)

export default component.exports